import { render } from "./CoupleView.vue?vue&type=template&id=40a89f6b&scoped=true"
import script from "./CoupleView.vue?vue&type=script&lang=js"
export * from "./CoupleView.vue?vue&type=script&lang=js"

import "./CoupleView.vue?vue&type=style&index=0&id=40a89f6b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-40a89f6b"

export default script